import { useContext } from "react";
import { CdpConfigContext } from "./provider";
/**
 * Access the Cdp Config object from context
 */
export const useConfig = () => {
    const context = useContext(CdpConfigContext);
    if (!context) {
        throw new Error("CdpConfigContext must be used within a CdpConfigProvider");
    }
    return context;
};
export const useEnv = () => useConfig().env;
export const usePortal = () => useConfig().portal;
export const useFeaturesEnabled = () => useConfig().featuresEnabled;
export const useCustomerActionConfig = () => useConfig().customerActionEnabled;
export const useCrsBaseUrl = () => useConfig().crsBaseUrl;
export const usePreviewMode = () => useConfig().previewMode;
export const useMapboxToken = () => {
    var _a, _b;
    const mapboxToken = (_b = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.mapboxToken) !== null && _b !== void 0 ? _b : "";
    try {
        return JSON.parse(mapboxToken)["mapbox_api_token"];
    }
    catch (e) {
        return undefined;
    }
};
export const useBrand = () => useConfig().brand;
export const useTrackingSite = () => useConfig().trackingSite;
